var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCentos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#932279",
    d: "m107.86 118.641 9.229 9.177-9.229 9.175H42.901v30.571L3.286 127.818l39.615-39.08v29.903zm28.554-78.068h78.929v78.93h-78.929z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFA724",
    d: "m137.275 107.86-9.175 9.229-9.175-9.229V42.901H88.352L128.1 3.286l39.077 39.615h-29.902zm-.86 28.554h78.928v78.93h-78.929z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#262577",
    d: "m148.057 137.275-9.23-9.175 9.23-9.175h64.958V88.352l39.617 39.748-39.617 39.077v-29.902zm-107.484-.86h78.929v78.93H40.573z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#9CCD2A",
    d: "m118.641 148.057 9.175-9.23 9.177 9.23v64.96h30.571l-39.748 39.615-39.076-39.615h29.901zM40.573 40.573h78.929v78.93H40.573z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M37.754 37.754h84.567v84.567H37.754zm5.637 78.93h73.291V43.393H43.391zm90.206-78.93h84.567v84.567h-84.567zm5.637 78.93h73.291V43.393h-73.291zm-5.637 16.913h84.567v84.569h-84.567zm5.637 78.928h73.291v-73.291h-73.291zm-101.48-78.928h84.567v84.569H37.754zm5.637 78.928h73.291v-73.291H43.391z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m60.188 187.758-59.8-59.8L60.187 68.16l59.8 59.798zm-51.826-59.8 51.826 51.826 51.824-51.826-51.826-51.824zm119.596-7.972L68.16 60.188l59.798-59.8 59.798 59.8zM76.134 60.188l51.824 51.824 51.826-51.824-51.826-51.826zm119.596 127.57-59.798-59.8L195.73 68.16l59.798 59.798zm-51.826-59.8 51.826 51.826 51.824-51.826-51.824-51.824zm-15.946 127.57L68.16 195.73l59.798-59.798 59.798 59.798zM76.134 195.73l51.824 51.824 51.826-51.824-51.826-51.824z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentos);
export default __webpack_public_path__ + "static/media/centos.c96ecf24bcdfd84b6927fb06072009a8.svg";
export { ForwardRef as ReactComponent };